export const AUTH_BROADCAST_CHANNEL = 'auth';

export enum EAuthMessages {
  USER_LOGGED_IN = 'userLoggedIn',
  USER_LOGGED_OUT = 'userLoggedOut',
  USER_REFRESHING = 'userRefreshing',
  USER_REFRESHED = 'userRefreshed'
}

interface IAuthMessage {
  message: EAuthMessages;
}

export interface IAuthUserLoggedInMessage extends IAuthMessage {
  message: EAuthMessages.USER_LOGGED_IN;
}
export interface IAuthUserLoggedOutMessage extends IAuthMessage {
  message: EAuthMessages.USER_LOGGED_OUT;
  uid: string;
}
export interface IAuthUserRefreshingMessage extends IAuthMessage {
  message: EAuthMessages.USER_REFRESHING;
  uids: number[];
}
export interface IAuthUserRefreshedMessage extends IAuthMessage {
  message: EAuthMessages.USER_REFRESHED;
  uids: number[];
}

export type IAuthMessages =
  | IAuthUserLoggedInMessage
  | IAuthUserLoggedOutMessage
  | IAuthUserRefreshingMessage
  | IAuthUserRefreshedMessage;

export type IAuthChannelEventListener = (event: MessageEvent<IAuthMessages>) => void;
